import { action, makeObservable, observable } from 'mobx';

class AuthorizationStore {
  @observable isLoggedIn = true;

  isLoggedOutModalOn: boolean = false;

  constructor() {
    makeObservable(this);
  }

  @action setIsLoggedIn(value: boolean) {
    this.isLoggedIn = value;
  }

  setIsLoggedOutModalOn(value: boolean) {
    this.isLoggedOutModalOn = value;
  }
}

export const auth = new AuthorizationStore();
